import $ from 'jquery'

$(document).on('click', '#overlay-toggle', function (e) {
  $('body').toggleClass('overlay-on');
  $('#overlay-menu .header-menu-dropdown.is-active').removeClass('is-active');
  e.preventDefault();
});

if ($('.hero--light-blue').length || $('.hero--dark-blue').length || $('.hero--oval-shape-blue').length || $('.page-template-page-newsletter').length) {
  $('#header-menu > .menu-item:last-child a').addClass('mg-button--tertiary');
}


$('.header-menu-dropdown').on('click', function (e) {
  e.preventDefault();
  $(this).parent().find('.menu-item-has-children').toggleClass('is-active');
  $(".overlay-wrapper").addClass('is-active');
});

$(".menu-dropdown-mobile-back").on('click', function (e) {
  e.preventDefault();
  $(".overlay-wrapper").removeClass('is-active');
  $(".menu-item-has-children.is-active").removeClass('is-active');
  $(".header .menu-dropdown .header-menu-dropdown:after").css('transform', 'rotate(0deg)');
});

// Add hover functionality with delay
let hoverTimeout;

$('.header-menu .menu-dropdown').on('mouseenter', function() {
  clearTimeout(hoverTimeout);
  // Remove visible class from all other menu items
  $('.menu-item-has-children').not($(this).find('.menu-item-has-children')).removeClass('visible');
  // Add visible class to current menu item
  $(this).find('.menu-item-has-children').addClass('visible');
});

$('.header-menu .menu-dropdown').on('mouseleave', function() {
  const $this = $(this);
  hoverTimeout = setTimeout(function() {
    if (!$this.find('.menu-item-has-children').is(':hover') && !$this.is(':hover')) {
      $this.find('.menu-item-has-children').removeClass('visible');
    }
  }, 200); // 100ms delay
});

// Prevent menu from disappearing when hovering over child elements
$('.menu-item-has-children').on('mouseenter', function() {
  clearTimeout(hoverTimeout);
});

$('.menu-item-has-children').on('mouseleave', function() {
  const $this = $(this);
  hoverTimeout = setTimeout(function() {
    if (!$this.is(':hover') && !$this.closest('.menu-dropdown').is(':hover')) {
      $this.removeClass('visible');
    }
  }, 100); // 100ms delay
});

